<script>

import VueCharts from 'vue-chartjs'
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['maxScore'],
  mixins: [mixins.reactiveProp],
  mounted () {
    this.renderChart(this.chartData, {
        responsive: true,
        maintainAspectRatio: true,
        devicePixelRatio: 3,
        scales: {
            xAxes: [{
                gridLines: {
                    display: true
                }
            }],
            yAxes: [{
                gridLines: {
                    display: true
                },
                ticks: {
                    min: 0,
                    max: this.maxScore >= 90 ? 100 : this.maxScore + 10,
                    stepSize: 10,
                }
            }]
        }
    })
  }
}

</script>